import {
  type AxiosRequestConfig,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import type { ProofOfWork } from './types';
import { apiRoutes } from '@/api/api-routes';

export type ProofOfWorkParams = {
  user_type: ProofOfWork['user_type'];
  reason_type: ProofOfWork['reason_type'];
  status?: ProofOfWork['status'];
  service_id: string;
  delivery_type: ProofOfWork['delivery_type'];
  group_star?: number;
};

export const getProofOfWorkListFn = async (
  params: ProofOfWorkParams,
  config?: AxiosRequestConfig
) => {
  const response = await publicHttpClient.get<ProofOfWork[]>(
    apiRoutes.master_data.getProofOfWorkList,
    {
      params,
      ...config,
    }
  );
  return response.data;
};
